module.exports = __webpack_public_path__ + "static/img/formHead@2x.d45712f0.png";